// Sign in with Clerk, then ask the API who we are. Only allowlisted staff get past.
import { SignIn, SignedIn, SignedOut, useAuth, useClerk } from '@clerk/clerk-react';
import React from 'react';
import { registerTokenGetter } from '../api/client';
import { GLoading, GPill } from '../design/atoms';
import { useResources } from '../store/resourceStore';
import { useSession } from '../store/sessionStore';

function Centered({ children }: { children: React.ReactNode }) {
  return <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>{children}</div>;
}

function Allowlisted({ children }: { children: React.ReactNode }) {
  const { getToken, userId } = useAuth();
  const { signOut } = useClerk();
  const { status, error, load, reset } = useSession();

  const resetResources = useResources((s) => s.reset);
  React.useEffect(() => {
    registerTokenGetter(() => getToken());
    reset();
    resetResources(); // nothing cached survives an account switch
    void load();
  }, [userId, getToken, load, reset, resetResources]);

  if (status === 'idle' || status === 'loading') return <Centered><GLoading label="Checking who you are…" /></Centered>;
  if (status === 'denied' || status === 'error') {
    return (
      <Centered>
        <div style={{ background: 'var(--bg-panel)', borderRadius: 'var(--r-card)', padding: 28, maxWidth: 440 }}>
          <div style={{ fontFamily: 'var(--ff-sans)', fontSize: 20, fontWeight: 500, letterSpacing: '-0.02em' }}>
            {status === 'denied' ? 'This account is not on the list' : "Couldn't reach the dashboard API"}
          </div>
          <div style={{ fontFamily: 'var(--ff-code)', fontSize: 12.5, color: 'var(--fg-3)', marginTop: 10, lineHeight: 1.5, overflowWrap: 'anywhere' }}>{error}</div>
          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <GPill onClick={() => void load()}>Try again</GPill>
            <GPill onClick={() => void signOut()}>Sign out</GPill>
          </div>
        </div>
      </Centered>
    );
  }
  return <>{children}</>;
}

export function Gate({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedOut>
        <Centered>
          <div>
            <div style={{ fontFamily: 'var(--ff-mono)', fontSize: 13, color: 'var(--fg-3)', marginBottom: 14, textAlign: 'center' }}>Projector admin · staff only</div>
            <SignIn routing="hash" />
          </div>
        </Centered>
      </SignedOut>
      <SignedIn><Allowlisted>{children}</Allowlisted></SignedIn>
    </>
  );
}
